export const enum OrderStatusTypeEnum {
    ACTIVE = 'active',
    DONE = 'done',
    CANCELED = 'canceled',
}